import React from "react";
import { useSelector } from "react-redux";
import ProductListCard from "./ProductListCard";

const TopRatedProducts = () => {
  const { topRatedProducts } = useSelector((state) => state.product);

  return (
    <>
      {topRatedProducts && topRatedProducts?.length > 0 && (
        <div
          className="col-xl-3 col-lg-4 col-md-6 mb-sm-5 mb-md-0 d-none d-xl-block wow animate__animated animate__fadeInUp"
          data-wow-delay=".3s"
        >
          <h4 className="section-title style-1 mb-30 animated animated">
            Top Rated
          </h4>
          <div className="product-list-small animated animated">
            {topRatedProducts.map((item, index) => (
              <ProductListCard key={index} item={item} />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default TopRatedProducts;
